/**
 * Para onde o chat vai quando a pessoa escolhe uma conversa. Na página do chat,
 * pelo endereço (/chat/:id?mensagem=...), como sempre. Na lateral, pela memória
 * da própria lateral: trocar de conversa ali não pode tirar a pessoa da tela em
 * que ela está trabalhando.
 */
import { useCallback, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { chatDaLateral, lembrarConversaDaLateral } from "./lateral";

function useNavegacaoDaPagina() {
  const navigate = useNavigate();
  const { conversaId = null } = useParams();
  const [params, setParams] = useSearchParams();
  const irPara = useCallback(
    (id, { mensagem = null, substituir = false } = {}) => navigate(`/chat/${id}${mensagem ? `?mensagem=${mensagem}` : ""}`, { replace: substituir }),
    [navigate],
  );
  const irParaLista = useCallback(() => navigate("/chat"), [navigate]);
  const esquecerParametros = useCallback(() => setParams({}, { replace: true }), [setParams]);
  return { conversaId, mensagemPedida: params.get("mensagem"), loteId: params.get("lote"), irPara, irParaLista, esquecerParametros };
}

function useNavegacaoDaLateral() {
  const [onde, setOnde] = useState(() => ({ conversaId: chatDaLateral().conversaId, mensagem: null }));
  const irPara = useCallback((id, { mensagem = null } = {}) => {
    lembrarConversaDaLateral(id);
    setOnde({ conversaId: id, mensagem });
  }, []);
  const irParaLista = useCallback(() => {
    lembrarConversaDaLateral(null);
    setOnde({ conversaId: null, mensagem: null });
  }, []);
  const esquecerParametros = useCallback(() => setOnde((o) => ({ ...o, mensagem: null })), []);
  return useMemo(
    () => ({ conversaId: onde.conversaId, mensagemPedida: onde.mensagem, loteId: null, irPara, irParaLista, esquecerParametros }),
    [onde, irPara, irParaLista, esquecerParametros],
  );
}

/** As duas formas têm a mesma cara (os dois hooks rodam sempre; vale a do lugar). */
export function useNavegacaoDoChat(naLateral) {
  const pagina = useNavegacaoDaPagina();
  const lateral = useNavegacaoDaLateral();
  return naLateral ? lateral : pagina;
}
